import { QuestionIcon } from '@phosphor-icons/react/dist/csr/Question'

export const HelpIcon = (props) => {
    return (
        <QuestionIcon
            aria-hidden="true"
            color="currentColor"
            focusable="false"
            size={24}
            weight="bold"
            {...props}
        />
    )
}
